document.addEventListener("DOMContentLoaded", function() {
    const euCountries = ["AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "ES", "FI", "FR", "GR", "HR", "HU", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PT", "RO", "SE", "SI", "SK"];

    fetch('/browsing_context_suggestions.json')
        .then(response => response.json())
        .then(data => {
            const countryCode = data.detected_values.country.handle;
            // Check if the detected country code is in the EU countries list
            const isInEU = euCountries.includes(countryCode);

            // Store this information for later use
            document.documentElement.setAttribute("data-user-location", isInEU ? "eu" : "non-eu");
            // KARAAT custom (2026-07-09): also expose the specific country code so custom.js
            // can tell Norway/Switzerland (taxes & duties prepaid) apart from other non-EU countries.
            document.documentElement.setAttribute("data-user-country", countryCode);
        })
        .catch(error => console.error('Error fetching geolocation data:', error));
});
